import uuid from 'uuid'

// The prop a column sorts by.
export const columnSortProp = (column) => column.sortProp || column.prop

// A sort prop with slashes written as dots, as the backends take it.
export const formatSortProp = (prop = '') => prop.replace(/\//g, '.')

// Computes the next sort state for a column. If the column is already the
// active sort, its direction is toggled; otherwise a fresh descending sort is
// started. Shared by DataTable.vue and ReferralsList.vue to keep their
// initSort logic identical without duplicating the block.
export const getNextSort = function (currentSort, column) {
  const sortProp = columnSortProp(column)
  if (currentSort && currentSort.prop === sortProp) {
    return {
      ...currentSort,
      key: uuid.v4(),
      direction: currentSort.direction === 'desc' ? 'asc' : 'desc',
    }
  }
  return {
    key: uuid.v4(),
    id: column._t_id,
    prop: sortProp,
    direction: 'desc',
  }
}

export const sort = function () {
  let arrayOfSort = []
  let esSort = {}
  let currentItem = null
  const get = function () {
    return arrayOfSort
  }

  const add = function (sortItem) {
    const prop = formatSortProp(sortItem.prop)
    if (typeof prop === 'undefined' || !prop) {
      return
    }
    arrayOfSort = []
    arrayOfSort.push(['sort[0][field]', prop])
    arrayOfSort.push(['sort[0][dir]', sortItem.direction])
    esSort = [
      {
        [prop]: {
          order: sortItem.direction,
        },
      },
    ]
    currentItem = { id: sortItem.id, prop: sortItem.prop, direction: sortItem.direction }
  }

  const set = function (sortList) {
    arrayOfSort = sortList
    currentItem = null
  }

  const asQueryParams = function () {
    return arrayOfSort
      .filter((f) => f[0] !== null)
      .map((f) => `${f[0]}=${f[1]}`)
      .join('&')
  }

  const asESSort = function () {
    return esSort
  }

  // The last sort add() accepted, as { id, prop, direction }.
  const getItem = function () {
    return currentItem
  }

  return {
    get,
    set,
    add,
    asESSort,
    asQueryParams,
    getItem,
  }
}
